module.exports = __webpack_public_path__ + "img/size.d98fcec2.png";